import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LocationType,
} from 'app/enums/label.enums'

import {
    LoggerResponse,
} from '../Loggers.types'
import {
    availableLoggerStatuses,
} from '../Logger/Logger.utils'
import {
    loggerGatewayCardFields, loggerTransmissionFields,
} from '../Logger/Logger.fields'

export type LoggerUpdate = {
    batteryVoltage: string | number,
    containerSerialNumber: string,
    hardwareVersion?: string,
    softwareVersion?: string,
    lastCalibratedOn?: string,
    'gateway.locationRemark': string,
    'gateway.location.id': string,
    'gateway.areaName': string,
    'gateway.gatewayImeiMac': string,
}

type LoggerUpdateFields = LoggerUpdate & LoggerResponse & {
    'gateway.gatewayImeiMac': string,
}

const loggerUpdateFields = (rentingCompany): DTOCardFormField<keyof LoggerUpdateFields>[] => {
    return [
        {
            id: 'loggers',
            title: 'Logger',
            className: 'loggers',
            fields: [
                {
                    id: 'column1',
                    fields: [
                        {
                            name: 'loggerNumber',
                            componentName: 'InputSingleline',
                            disabled: true,
                            labelKey: 'Logger.loggerNumber',
                        },
                        {
                            name: 'loggerQrCode',
                            componentName: 'InputSingleline',
                            required: true,
                            labelKey: 'Logger.loggerQrCode',
                        },
                        {
                            name: 'containerSerialNumber',
                            componentName: 'InputSingleline',
                            disabled: true,
                            labelKey: 'Logger.containerSerialNumber',
                        },
                        {
                            name: 'loggerStatus',
                            componentName: 'EnumSelector',
                            allowedValues: availableLoggerStatuses,
                            useDropdown: true,
                            required: true,
                            labelKey: 'Logger.loggerStatus',
                        },
                        {
                            name: 'loggerType',
                            componentName: 'LoggerTypeSelector',
                            disabled: true,
                            labelKey: 'Logger.loggerType',
                        },
                    ],
                },
                {
                    id: 'column2',
                    fields: loggerTransmissionFields,
                },
                {
                    id: 'column3',
                    fields: [
                        {
                            name: 'isTestingLogger',
                            labelKey: 'Logger.isTestingLogger',
                            componentName: 'Checkbox',
                        },
                        {
                            name: 'hardwareVersion',
                            componentName: 'InputSingleline',
                            labelKey: 'Logger.hardwareVersion',
                        },
                        {
                            name: 'softwareVersion',
                            componentName: 'InputSingleline',
                            labelKey: 'Logger.softwareVersion',
                        },
                        {
                            name: 'location',
                            componentName: 'LocationObjectSelector',
                            filterLocationType: LocationType.ADDRESS,
                            labelKey: 'Container.location',
                        },
                        {
                            name: 'rentingCompany',
                            componentName: 'CompanyObjectSelector',
                            labelKey: 'Logger.rentingCompany',
                            disabled: !!rentingCompany,
                        },
                        {
                            name: 'batteryVoltage',
                            componentName: 'IntegerInput',
                            disabled: true,
                            labelKey: 'Logger.batteryVoltage',
                        },
                        {
                            name: 'destinationLocation',
                            componentName: 'LocationObjectSelector',
                        },
                    ],
                },

            ],
        },
        loggerGatewayCardFields,
    ]
}

export default loggerUpdateFields
